/**
 * /!\ This file is auto-generated.
 *
 * This is the entry point of your standalone application.
 *
 * There are multiple tags used by the editor to inject code automatically:
 *     - `wle:auto-imports:start` and `wle:auto-imports:end`: The list of import statements
 *     - `wle:auto-register:start` and `wle:auto-register:end`: The list of component to register
 */

/* wle:auto-imports:start */
import {AudioListener} from '@wonderlandengine/components';
import {Cursor} from '@wonderlandengine/components';
import {CursorTarget} from '@wonderlandengine/components';
import {FingerCursor} from '@wonderlandengine/components';
import {HandTracking} from '@wonderlandengine/components';
import {MouseLookComponent} from '@wonderlandengine/components';
import {PlayerHeight} from '@wonderlandengine/components';
import {TeleportComponent} from '@wonderlandengine/components';
import {VrModeActiveSwitch} from '@wonderlandengine/components';
import {WasdControlsComponent} from '@wonderlandengine/components';
import {ButtonComponent} from './button.js';
import {Keyboard} from './keyboard.js';
import {MobileTouchControls} from './mobile-touch-controls.js';
import {NetworkButtons} from './network-buttons.js';
import {PeerManager} from './networking.js';
import {PeerNetworkedPlayer} from './networking.js';
import {PeerNetworkedPlayerPool} from './networking.js';
/* wle:auto-imports:end */

export default function(engine) {
/* wle:auto-register:start */
engine.registerComponent(AudioListener);
engine.registerComponent(Cursor);
engine.registerComponent(CursorTarget);
engine.registerComponent(FingerCursor);
engine.registerComponent(HandTracking);
engine.registerComponent(MouseLookComponent);
engine.registerComponent(PlayerHeight);
engine.registerComponent(TeleportComponent);
engine.registerComponent(VrModeActiveSwitch);
engine.registerComponent(WasdControlsComponent);
engine.registerComponent(ButtonComponent);
engine.registerComponent(Keyboard);
engine.registerComponent(MobileTouchControls);
engine.registerComponent(NetworkButtons);
engine.registerComponent(PeerManager);
engine.registerComponent(PeerNetworkedPlayer);
engine.registerComponent(PeerNetworkedPlayerPool);
/* wle:auto-register:end */
}
